import * as api2 from 'Cloud/Application/api';
import {
    EAttachesFetch,
    EAttachesFolder,
    EAttachesFoldersFetch,
    EAttachesLoad,
    EAttachesOpenViewer,
    EAttachesPage,
    EAttachesPageStart,
    EAttachesViewer,
} from 'reactApp/modules/attaches/attaches.constants';
import { AttachesSearchParams } from 'reactApp/modules/attaches/attaches.types';
import { MemoryCache } from 'reactApp/modules/cache/MemoryCache';
import { getAttachesCacheTtlMs } from 'reactApp/modules/features/features.selectors';
import { RootState } from 'reactApp/store';
import { promisifyDeferredCall } from 'reactApp/utils/helpers';
import { Action, AnyAction } from 'redux';
import { ThunkAction } from 'redux-thunk';

const cache = new MemoryCache();

export const request = (payload: AttachesSearchParams = {}): AnyAction => ({
    type: EAttachesFetch.REQUEST,
    payload,
});

export const success = (payload: any): AnyAction => ({
    type: EAttachesFetch.SUCCESS,
    payload,
});

export const failure = (error: any): AnyAction => ({
    type: EAttachesFetch.FAILURE,
    error,
});

export const attachesLoadMoreRequest = (payload: AttachesSearchParams): AnyAction => ({
    type: EAttachesLoad.REQUEST,
    payload,
});

export const resetState = (): Action => ({
    type: EAttachesPage.RESET,
});

const requestFolders = (payload: AttachesSearchParams = {}): AnyAction => ({
    type: EAttachesFoldersFetch.REQUEST,
    payload,
});

const successFolders = (payload: any): AnyAction => ({
    type: EAttachesFoldersFetch.SUCCESS,
    payload,
});

const failureFolders = (error: any): AnyAction => ({
    type: EAttachesFoldersFetch.FAILURE,
    error,
});

export const getAttachFolders = (): ThunkAction<Promise<unknown>, RootState, unknown, AnyAction> => (dispatch, getState) =>
    new Promise<AnyAction>((resolve, reject): void => {
        const ttl = getAttachesCacheTtlMs(getState());
        const key = `getfolders`;

        dispatch(requestFolders());

        cache
            .getOrAdd(key, () => promisifyDeferredCall(api2.mail.user.folders), ttl)
            .then((response): void => resolve(dispatch(successFolders(response))))
            .catch((error): void => reject(dispatch(failureFolders(error))));
    });

export const toggleFolder = (payload: { id: string }): AnyAction => ({
    type: EAttachesFolder.TOGGLE,
    payload,
});

export const attachesPageStart = (payload: {
    initialId: string;
    messageId: string;
}): AnyAction => ({
    type: EAttachesPageStart.REQUEST,
    payload,
});

export const attachesViewerLoadMore = (payload: any): AnyAction => ({
    type: EAttachesViewer.LOADMORE,
    payload,
});

export const attachesViewerSuccess = (payload: any): AnyAction => ({
    type: EAttachesViewer.SAVE,
    payload,
});

export const attachesOpenViewer = (payload: { id: string; }): AnyAction => ({
    type: EAttachesOpenViewer.REQUEST,
    payload,
});
